import React from 'react';
import { usersPageAction } from 'src/components/profileComponents/Users/types';
import Box from '@mui/material/Box';
import { useHistory } from 'react-router';
import { useGlobalGrid } from 'src/hooks/app/use-global-grid';
import { useStyles } from './styles';

export const UserAction: React.FC<{action: usersPageAction}> = ({ action }) => {
  const { getGridsWidth } = useGlobalGrid();
  const styles = useStyles(getGridsWidth);
  const history = useHistory();
  const onClick = () => {
    if (action.link) {
      history.push(action.link);
    }
  };
  return (
    <>
      <Box className={styles.actionWrapper} onClick={onClick}>
        <Box
          className={styles.actionIcon}
          style={{
            background: `url(${action.icon}) center no-repeat`,
          }}
        />
        <div className={styles.actionNameWrapper}>
          <div className={styles.actionNameText}>
            <div className={`${styles.actionNameTextItem} ${styles.actionName}`}>{action.name}</div>
            <div className={`${styles.actionNameTextItem} ${styles.actionDescription}`}>{action.description}</div>
          </div>
        </div>
        <Box ml="auto">
          <div className={styles.actionBtnWrapper}>
            <div
              className="actionChevron"
              style={{
                background: `url(${action.btn}) center no-repeat`,
              }}
            />
          </div>
        </Box>
      </Box>
    </>
  );
};
